import dynamic from "next/dynamic";
import Head from "next/head";
import { useRouter } from "next/router";

import { useEffect, useMemo } from "react";

import { profileUrl } from "components/ProfilePageLayout";
import { useApi } from "hooks/useApi";

const ProfilePageInsightsList = dynamic(
  () =>
    import(
      "components/ProfilePageLayout/ProfilePageAnalysis/ProfilePageInsightsList"
    )
);

const ProfilePageReportsList = dynamic(
  () =>
    import(
      "components/ProfilePageLayout/ProfilePageAnalysis/ProfilePageReportsList"
    )
);

type ProfilePageAnalysisProps = {};

const ProfilePageAnalysis = ({}: ProfilePageAnalysisProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;
  const currentTab = router.query.tab;

  const isCompany = router.route.startsWith("/companies/[slug]");

  const { data: profile } = useApi(profileUrl(slug, isCompany));
  const { name, companyName } = profile || {};

  const tabContent = useMemo(() => {
    if (currentTab === "reports") {
      return <ProfilePageReportsList />;
    }
    return <ProfilePageInsightsList />;
  }, [currentTab]);

  useEffect(() => {
    if (!profile?.hadInsightsPublished && !profile?.hadReportsPublished) return;

    if (currentTab === "reports" && !profile?.hadReportsPublished) {
      router.replace(
        `/${isCompany ? "companies" : "profiles"}/${slug}/research`
      );
    }
    if (
      (!currentTab || currentTab === "insights") &&
      !profile?.hadInsightsPublished
    ) {
      router.replace(
        `/${isCompany ? "companies" : "profiles"}/${slug}/research?tab=reports`
      );
    }
  }, [
    currentTab,
    isCompany,
    profile?.hadInsightsPublished,
    profile?.hadReportsPublished,
    router,
    slug,
  ]);

  const title = `${name}${companyName ? ` - ${companyName}` : ""} - Research`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={title} />
      </Head>
      {tabContent}
    </>
  );
};

export default ProfilePageAnalysis;
